export default Object.freeze({
    LOGIN: 'login',
    LOOKUP_ACCOUNT: 'lookup_account',
    REGISTER_OR_GHOST: 'register_or_ghost',
});



// WEBPACK FOOTER //
// ./src/Assets/components/Users/LoginOrSignup/consts/stages.js